import {
  Container,
  Heading,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from "@chakra-ui/react"
import { createFileRoute } from "@tanstack/react-router"

import Appearance from "../../components/UserSettings/Appearance"
import ChangePassword from "../../components/UserSettings/ChangePassword"
/*import DeleteAccount from "../../components/UserSettings/DeleteAccount"*/
import UserInformation from "../../components/UserSettings/UserInformation"
import Policy from "../../components/UserSettings/Policy"
import { useTranslation } from "react-i18next";

const tabsConfig = [
  { titleKey: "settings.tabs.profile", component: UserInformation },
  { titleKey: "settings.tabs.password", component: ChangePassword },
  { titleKey: "settings.tabs.appearance", component: Appearance },
  { titleKey: "settings.tabs.policy", component: Policy }
 /* { title: "Danger zone", component: DeleteAccount },*/
]

export const Route = createFileRoute("/_layout/settings")({
  component: UserSettings,
})

function UserSettings() {
  const { t } = useTranslation()
  const finalTabs = tabsConfig

  return (
    <Container maxW="full">
      <Heading size="lg" textAlign={{ base: "center", md: "left" }} py={2}>
        {t("settings.heading")}
      </Heading>
      <Tabs variant="enclosed">
        <TabList>
          {finalTabs.map((tab, index) => (
              <Tab key={index}>{t(tab.titleKey)}</Tab>
          ))}
        </TabList>
        <TabPanels>
          {finalTabs.map((tab, index) => (
            <TabPanel key={index}>
              <tab.component />
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Container>
  )
}
